/** Debug usage tally tracker - console logging only */
export class DebugTallyTracker {
  /** Debug mode enabled flag. */
  private enableDebug: boolean;

  /** Map of count values to usage frequency. */
  private usageTally: Map<number, number>;

  /** Set of unique count values requested. */
  private uniqueRequestsSet: Set<number>;

  /** Total number of unique row count values requested. */
  private uniqueRowCountRequestsTally: number;

  /** Initialize debug tracker with enable flag. */
  constructor(enableDebug: boolean) {
    this.enableDebug = enableDebug;
    this.usageTally = new Map();
    this.uniqueRequestsSet = new Set();
    this.uniqueRowCountRequestsTally = 0;

    if (this.enableDebug) {
      console.log('🔍 RowCount Debug Mode: ENABLED');
      console.log('📊 Usage tracking started for RowCountProvider');
    }
  }

  /** Track usage of a specific count value. */
  trackUsage(count: number): void {
    if (!this.enableDebug) return;

    const currentTally = this.usageTally.get(count) || 0;
    const newTally = currentTally + 1;
    this.usageTally.set(count, newTally);

    // Track unique requests
    if (!this.uniqueRequestsSet.has(count)) {
      this.uniqueRequestsSet.add(count);
      this.uniqueRowCountRequestsTally++;
    }

    // Console output
    console.log(
      `📈 RowCount Usage: ${count.toLocaleString()} (tally: ${newTally}, unique: ${this.uniqueRowCountRequestsTally})`,
    );

    // Show current state
    if (this.usageTally.size > 1) {
      console.log('📋 Current usage tallies:', Object.fromEntries(this.usageTally));
    }
  }

  /** Check if debug is enabled. */
  isDebugEnabled(): boolean {
    return this.enableDebug;
  }
}
